import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, X } from 'lucide-react';
import axios from 'axios';

const InclinedBungyPromo = () => {
  const navigate = useNavigate();
  const [newEraVideo, setNewEraVideo] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);

  useEffect(() => {
    // Fetch new-era video
    const fetchNewEraVideo = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL || '';
        const response = await axios.get(`${API}/api/videos`);
        const video = response.data.find(v => v.type === 'new-era' && v.isActive);
        if (video) {
          setNewEraVideo(video);
        }
      } catch (error) {
        console.error('Error fetching new-era video:', error);
      }
    };
    fetchNewEraVideo();
  }, []);

  const handleBookNow = () => {
    navigate('/location/goa');
  };

  const handlePlayVideo = () => {
    if (newEraVideo) {
      setShowVideoModal(true);
    }
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  // Helper to get YouTube embed URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    
    let videoId = null;
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    } else if (url.includes('youtube.com/embed/')) {
      return url;
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    }
    
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }
    return url;
  };

  const isYouTube = (url) => {
    return url && (url.includes('youtube.com') || url.includes('youtu.be'));
  };

  return (
    <section className="relative bg-white py-8 md:py-16 md:px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section - White Background on Mobile, Above video on desktop */}
        <div className="bg-white text-center mb-0 md:mb-12 py-6 md:py-0 px-4">
          {/* Introducing - Mobile Only */}
          <p className="md:hidden text-sm font-semibold uppercase mb-2 text-black">
            Introducing
          </p>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase mb-1 md:mb-2" style={{ color: '#FACC15' }}>
            NEW ERA OF
          </h2>
          <h3 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black uppercase text-black">
            BUNGY JUMP
          </h3>
        </div>

        {/* Video Card - Full width on mobile, contained on desktop */}
        <div className="relative md:max-w-5xl md:mx-auto md:rounded-3xl overflow-hidden shadow-2xl">
          {/* Background Image with overlay */}
          <div className="relative h-[60vh] md:h-auto md:aspect-video bg-cover bg-center" style={{ backgroundImage: `url('/bg-new.png')` }}>
            <div className="absolute inset-0 bg-gradient-to-b from-black/28 via-black/21 to-black/42"></div>
            
            {/* Content */}
            <div className="relative h-full flex flex-col justify-between p-6 sm:p-8 md:p-12 lg:p-16">
              
              {/* Play Button - Centered on Mobile, Left on Desktop */}
              <div className="flex-1 flex items-center justify-center md:justify-start">
                <button 
                  onClick={handlePlayVideo}
                  className="w-12 h-12 sm:w-14 sm:h-14 md:w-20 md:h-20 rounded-full bg-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform group"
                  disabled={!newEraVideo}
                >
                  <div className="w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-l-[14px] md:border-t-[12px] md:border-b-[12px] md:border-l-[16px] ml-1" style={{ borderLeft: '14px solid #1E3A8A' }}></div>
                </button>
              </div>

              {/* Text Overlay - Visible on Desktop */}
              <div className="hidden md:flex flex-1 items-center">
                <div className="max-w-xl">
                  <h4 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-white uppercase leading-tight mb-2 lg:mb-4">
                    INDIAS FIRST AND ONLY
                  </h4>
                  <h4 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-white uppercase leading-tight mb-2 lg:mb-4">
                    inclined and thrilling
                  </h4>
                  <h4 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-white uppercase leading-tight">
                    BUNGY JUMP
                  </h4>
                </div>
              </div>

              {/* Bottom Section - Text on Mobile, CTA on all */}
              <div className="flex flex-col md:flex-row items-center md:items-end justify-between space-y-4 md:space-y-0">
                {/* Text - On video for mobile - Same as desktop but 120% larger */}
                <div className="md:hidden text-center">
                  <h4 className="text-3xl sm:text-4xl font-black text-white uppercase leading-tight mb-2">
                    INDIAS FIRST AND ONLY
                  </h4>
                  <h4 className="text-3xl sm:text-4xl font-black text-white uppercase leading-tight mb-2">
                    inclined and thrilling
                  </h4>
                  <h4 className="text-3xl sm:text-4xl font-black uppercase leading-tight" style={{ color: '#FACC15' }}>
                    BUNGY JUMP
                  </h4>
                </div>

                {/* CTA Button - Blue background with white text */}
                <button
                  onClick={handleBookNow}
                  className="text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-black text-sm sm:text-base md:text-lg transition-all transform hover:scale-105 shadow-xl uppercase md:ml-auto"
                  style={{ backgroundColor: '#00A8E1' }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#00B8F1'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#00A8E1'}
                >
                  EXPERIENCE THE THRILL
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Video Modal */}
      {showVideoModal && newEraVideo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm p-4">
          <button
            onClick={closeVideoModal}
            className="absolute top-4 right-4 text-white hover:text-yellow-400 transition-colors z-50"
          >
            <X size={32} />
          </button>

          <div className="w-full max-w-5xl aspect-video">
            {isYouTube(newEraVideo.url) ? (
              <iframe
                className="w-full h-full rounded-2xl"
                src={getYouTubeEmbedUrl(newEraVideo.url)}
                title={newEraVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <video
                className="w-full h-full rounded-2xl bg-black"
                controls
                autoPlay
                src={newEraVideo.url}
              >
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default InclinedBungyPromo;
